module.exports = __webpack_public_path__ + "static/media/konqyuan3.ea343456.jpg";